import { ISbRichtext } from '@storyblok/react';
import { clsx } from 'clsx';
import { FC } from 'react';
import { Components } from 'react-markdown';
import { RichTextStoryblok, TableStoryblok } from 'storyblok-types';
import { Image } from 'atoms/Image/Image';
import { Body, HeadLine } from 'atoms/Typography/Typography';
import { ReactMarkdown } from 'molecules/Markdown';
import { renderRichText } from 'modules/stroyblok/services';
import { ContentTable } from './ContentTable';
import styles from './styles.module.css';

const componentResolver = (component: string, blok: TableStoryblok) => {
  switch (component) {
    case 'table':
      return `<div datatype="blok">${JSON.stringify(blok)}</div>`;
    default:
      return '';
  }
};

export const RichTextMarkdown: FC<{
  text?: string | ISbRichtext;
  className?: string;
  components?: Components;
}> = ({ text, className, components }) => {
  return (
    <ReactMarkdown
      className={className}
      text={
        typeof text === 'string'
          ? text
          : renderRichText(text, { resolver: componentResolver })
      }
      components={{
        p: ({ children }) => (
          <Body
            type="sm"
            className={clsx(styles.content, styles.text, className)}
          >
            {children}
          </Body>
        ),
        h2: ({ children }) => (
          <HeadLine type="xs" tag="h2" className={styles.title}>
            {children}
          </HeadLine>
        ),
        img: ({ src, alt }) => (
          <Image className={styles.contentImage} src={src} alt={alt} />
        ),
        div({ children }) {
          try {
            if (Array.isArray(children)) {
              return <ContentTable blok={JSON.parse(children.join(''))} />;
            }
            if (typeof children === 'string') {
              return <ContentTable blok={JSON.parse(children)} />;
            }
          } catch (err) {
            return <div>{children}</div>;
          }
          return <div>{children}</div>;
        },
        ...components,
      }}
    />
  );
};

export const RichText: FC<{ blok: RichTextStoryblok; className?: string }> = ({
  blok,
  className,
}) => {
  return <RichTextMarkdown className={className} text={blok?.text} />;
};
